<template>
  <div></div>
</template>
<script>
import { ZYToast } from '@zyf2e/adapt';
import jumpCenter from '@/mixins/jumpCenter';

export default {
  mixins: [jumpCenter],
  async created() {
    ZYToast.open('加载中');
    const { recommendId } = this.$route.query;
    const { status, orderId } = await this.$fetch.fetchGetRecommendStatus({ recommendId }).catch(err => err);
    switch (status) {
      case 1: // 推荐单已经生成
        this.jumpToMallOrderDetail(orderId, 0);
        break;
      case 2: //推荐已失效
        this.$router.replace({
          name: 'BindingDoctors',
          query: {
            isDrug: 0,
            recommendStatus: 2 // 代表推荐单已经失效
          }
        });
        break;
      case 3:
        this.$router.replace({
          name: 'Recommend',
          query: this.$route.query
        });
        break;

      default:
        this.$toast('推荐单生成异常,请关闭重试');
        break;
    }
  }
};
</script>
